import { GlobalError } from './GlobalError';
import { Api } from './api';
import { Start } from './Start';
import { Login } from './Login';
import { Browsing } from './Browsing';
import { IMediaService } from './Media';
import { IPopupsService } from './Popups';
import { IProductService } from './Product';

export enum ServiceName {
  GlobalError,
  Api,
  Start,
  Login,
  Browsing,
  MediaService,
  Popups,
  Product,
}

export type ServiceReference = Promise<Services>;

export type ServiceCast = GlobalError | Api | Start | Login | Browsing | IMediaService | IPopupsService | IProductService;

export interface Services {
  get<T extends ServiceCast>(name: ServiceName): T
}
